/* DSL Wishlist endpoint self-test — admin-only health-check bij console.log(+'+wlt()+'+) */
(function(){
  window.dsl_wlt = function(){
    if (!window.DSL_CUSTOMER || !window.DSL_CUSTOMER.id) return console.log("not logged in");
    fetch("/apps/dsl/wishlist?customer_id=" + window.DSL_CUSTOMER.id).then(function(r){
      if (!r.ok) return console.error("FAIL", r.status);
      return r.json();
    }).then(function(d){ console.log("WL endpoint OK:", d); }).catch(function(e){ console.error(e); });
  };
})();